/*
 * Copyright (c) 2020.
 * Simon
 */

import { CLEAR_STORE } from '../types';

/**
 * ClearStoreAction
 */
const ClearStoreAction = () => {
	return {
		type: CLEAR_STORE,
		payload: false
	};
};

export { ClearStoreAction };